import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback.
 * @see SvgIcon base class for propTypes.
 *
 * @static
 * * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a drop icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DropIcon width={12} />
 */
const DropIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M12.8,2.6c-0.44-0.33-1.16-0.33-1.6,0C11.2,2.6,4,8,4,14c0,4.42,3.58,8,8,8s8-3.58,8-8C20,8,12.8,2.6,
                12.8,2.6z M12.25,19c-3.7,0-5.05-2.71-5.24-4.15c-0.06-0.41,0.23-0.79,0.64-0.84c0.4-0.06,0.79,0.23,
                0.84,0.64c0.04,0.29,0.52,2.85,3.76,2.85c0.41,0,0.75,0.34,0.75,0.75S12.66,19,12.25,19z`}
        />
    </SvgIcon>
)

DropIcon.defaultProps = defaultProps

export { DropIcon }
